import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { FilterOption, FilterType } from 'apps/find-designers/propTypes';

function CheckableFilterOption({ filterOption, type, onChange, isChecked }) {
    return (
        <label className="field field--checkable field--block" htmlFor={filterOption.id}>
            <div className="field__input">
                <input
                    name={filterOption.name}
                    value={filterOption.value}
                    id={filterOption.id}
                    checked={isChecked}
                    type={type}
                    onChange={onChange}
                />
            </div>
            <span className="field__title field__title--subtle">{filterOption.title}</span>
        </label>
    );
}

CheckableFilterOption.propTypes = {
    type: FilterType.isRequired,
    onChange: PropTypes.func.isRequired,
    filterOption: FilterOption.isRequired,
    isChecked: PropTypes.bool.isRequired,
};

export default observer(CheckableFilterOption);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/CheckableFilterOption.jsx